module.exports = __webpack_public_path__ + "static/media/DevOps-vs-SRE.9e246b02.md";